import { Pipe, PipeTransform } from '@angular/core';

import { arrivalDaysFormatDateByRegex } from '@ux/mappers/date.mapper';

@Pipe({
  name: 'arrivalDays',
  standalone: false
})
export class ArrivalDaysPipe implements PipeTransform {

  constructor() { }

  transform(arrivalDate: string, departureDate: string): string {
    const departureDateDay = new Date(arrivalDaysFormatDateByRegex(departureDate)).getDate();
    const arrivalDateDay = new Date(arrivalDaysFormatDateByRegex(arrivalDate)).getDate();
    const days = arrivalDateDay - departureDateDay;
    return days > 0 ? `+${days}` : '';
  }
}
